module.exports = __webpack_public_path__ + "img/wncs.80cf853.png";